module.exports = __webpack_public_path__ + "static/img/bcg2.1f93a176.jpg";